import React from 'react'
import ForgotPasswordStepOneForm from '../../components/account/forgot-password-step-one-form'

const ForgotPasswordStepOne = () => {
    return (
        <>
            <ForgotPasswordStepOneForm />
        </>
    )
}

export default ForgotPasswordStepOne
